fetch("https://ipinfo.io/json")
  .then((response) => response.json())
  .then((data) => {
    if (data.country === "CA") {
      document.querySelectorAll(".js-header-currency-button").forEach((el) => {
        el.style.display = "inline-block";
      });
    } else {
      document
        .querySelector(".hide-extra-payment-methods")
        ?.classList.remove("hide-extra-payment-methods");
    }
  })
  .catch((error) => console.error("Country error:", error));

function chatButtonPosition() {
  var initGorgiasChatPromise = window.GorgiasChat
    ? window.GorgiasChat.init()
    : new Promise(function (resolve) {
        window.addEventListener("gorgias-widget-loaded", function () {
          resolve();
        });
      });
  initGorgiasChatPromise.then(() => {
    const sticky_add_to_cart = document.querySelector(".product-sticky-form");
    if (sticky_add_to_cart) {
      const add_to_cart_main = document.querySelector(
        ".shopify-section--main-product #AddToCart"
      );
      const add_to_cart_main_bottom =
        add_to_cart_main.getBoundingClientRect().bottom;
      const chat_button = document.querySelector("#chat-button");
      if (chat_button) {
        if (add_to_cart_main_bottom <= 80) {
          chat_button.classList.add("scroll-top");
        } else {
          chat_button.classList.remove("scroll-top");
        }
      }
    }
  });
}

document.addEventListener("scroll", () => chatButtonPosition());
class NoSignatureDelivery extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const checkbox = this.querySelector("#no-signature-delivery");
    if (checkbox) {
      checkbox.addEventListener("change", (e) => {
        const formData = new FormData();
        const attributeValue = e.target.checked ? "Yes" : "No";

        formData.append(
          "attributes[I want delivery without signature (scooters always require one)]",
          attributeValue
        );

        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Cart updated:", data);
          })
          .catch((error) => {
            console.error("Error updating cart:", error);
          });
      });
    }
  }
}
customElements.define("no-signature-delivery", NoSignatureDelivery);

// Handle Low Stock label visibility on variant change
document.addEventListener('variant:changed', function(event) {
  const variantId = event.detail.variant?.id;
  if (!variantId) return;

  // Find the product card container
  const productCard = event.target.closest('.new-product-card');
  if (!productCard) return;

  // Get the low stock data
  const dataScript = productCard.querySelector('script[data-low-stock-variants]');
  if (!dataScript) return;

  try {
    const lowStockData = JSON.parse(dataScript.textContent);
    const variantData = lowStockData[variantId];

    if (!variantData) return;

    // Find or create the low stock label
    let lowStockLabel = productCard.querySelector('.new-product-card__low-stock-label');

    // Determine if we should show the label
    const shouldShow = variantData.lowInStock && 
                       variantData.available && 
                       !variantData.hasIncomingDate &&
                       (variantData.inventoryPolicy === 'continue' || 
                        (variantData.inventoryPolicy !== 'continue' && variantData.inventoryQuantity > 0));

    if (shouldShow) {
      if (!lowStockLabel) {
        // Create the label if it doesn't exist
        lowStockLabel = document.createElement('div');
        lowStockLabel.className = 'new-product-card__low-stock-label';
        lowStockLabel.innerHTML = 'Low stock';

        const metaSection = productCard.querySelector('.new-product-card__meta');
        if (metaSection) {
          const priceList = metaSection.querySelector('.new-product__price-list');
          if (priceList) {
            metaSection.insertBefore(lowStockLabel, priceList);
          }
        }
      }
      lowStockLabel.style.display = 'inline-flex';
    } else if (lowStockLabel) {
      lowStockLabel.style.display = 'none';
    }
  } catch (e) {
    console.error('Error parsing low stock data:', e);
  }
});

// Back-to-Top Button (mobile only)
(function () {
  var btn = document.getElementById('back-to-top-btn');
  if (!btn) return;

  var stickyForm = null;
  var miniCartOpen = false;

  function updateBackToTop() {
    var scrolled = window.scrollY || document.documentElement.scrollTop;

    // Hide entirely when mini-cart drawer is open
    if (miniCartOpen) {
      btn.classList.remove('is-visible');
      return;
    }

    // Show after first viewport height
    if (scrolled > window.innerHeight) {
      btn.classList.add('is-visible');
    } else {
      btn.classList.remove('is-visible');
    }

    // Lift above sticky add-to-cart when it is visible
    if (!stickyForm) {
      stickyForm = document.querySelector('.product-sticky-form');
    }
    if (stickyForm && !stickyForm.hasAttribute('hidden')) {
      btn.style.bottom = (stickyForm.offsetHeight + 16) + 'px';
    } else {
      btn.style.bottom = '';
    }
  }

  document.addEventListener('scroll', updateBackToTop, { passive: true });

  // Hide when mini-cart opens, restore when it closes
  var miniCart = document.getElementById('mini-cart');
  if (miniCart) {
    miniCart.addEventListener('openable-element:open', function () {
      miniCartOpen = true;
      btn.classList.remove('is-visible');
    });
    miniCart.addEventListener('openable-element:close', function () {
      miniCartOpen = false;
      updateBackToTop();
    });
  }

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();